/*eslint-disable */
import userImage from '../../components/userimage/index.vue';
import toast from '../../services/toast';
import countries from '../../services/country.json';
import allCountries from './phoneCodeList.json';
const $ = window.jQuery = require('jquery');
import {
  mapGetters
} from 'vuex';
export default {
  name: 'profile-update',
  components: {
    'user-image': userImage,
  },
  props: [],
  data() {
    return {
      userDetails: '',
      department: '',
      area_of_work: '',
      area_of_interest: '',
      avatar: '',
      submitted: false,
      updatedMobile: '',
      first_name: '',
      last_name: '',
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      phoneNumber: {
        fullnumber:'',
        fullOTP:'',
        key1: '',
        key2: '',
        key3: '',
        key4: '',
        key5: '',
        key6: '',
        key7: '',
        key8: '',
        key9: '',
        key10: '',
        otp1:'',
        otp2:'',
        otp3:'',
        otp4:'',
        otp5:'',
        otp6:''
      },
      phoneNumUpdatedPopup: false,
      otpVerifyPopupShow: false,
      fullMobileCountryCode:'',
      countryList: [],
      allCountriesList: [],
      onCHangeCountryCode:'',
      sendingCountryCode:'',
      designation:'',
      country:'',
      city:'',
      userFilter:'',
      oncologist:false,
      other_doctor:false,
      medical_researcher:false,
      patient:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    setInitialState() {
      if (this.userDetails != undefined) {
        this.first_name = this.userDetails.first_name || '',
        this.last_name = this.userDetails.last_name || '',
        this.department = this.userDetails.profile.department || '',
        this.designation = this.userDetails.profile.designation || '',
        this.country = this.userDetails.profile.country || '',
        this.city = this.userDetails.profile.city || '',
        this.area_of_work = this.userDetails.profile.area_of_work || '',
        this.area_of_interest = this.userDetails.profile.area_of_interest || '',
        this.avatar = this.userDetails.profile.avatar
        this.oncologist = this.userDetails.profile.oncologist
        if(this.oncologist == true){
          this.userFilter = 'oncologist'
        }
        this.other_doctor = this.userDetails.profile.other_doctor
        if(this.other_doctor == true){
          this.userFilter = 'other_doctor'
        }
        this.medical_researcher = this.userDetails.profile.medical_researcher
        if(this.medical_researcher == true){
          this.userFilter = 'medical_researcher'
        }
        this.patient = this.userDetails.profile.patient
        if(this.patient == true){
          this.userFilter = 'patient'
        }
        this.phone.countryCode = this.userDetails.profile.mobile_country_code  || ''
        this.fullMobileCountryCode = this.phone.countryCode + ' ' + (this.userDetails.profile.mobile || '')
        this.phone.number = this.userDetails.profile.mobile || ''
        setTimeout(() =>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode.split('+')
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == countrySplit[1])[0].iso2;
            }
        },100)
      }
      return
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getUserDetailsAgainFun
    this.setInitialState
    setTimeout(() => {
      this.getUserCountry();
    }, 30); 
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
          if (self.phone.country == '' && self.phone.country != null) {
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
          }
          if(self.country == '') {
            //self.country = (text.substr(2, 2)).toLowerCase();
          }
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    getUserDetailsAgain() {
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.userDetails = res.data.data
      }).catch((err) => {
      })
    },
    FilterFieldChangeFun(){
      console.log(this.userFilter, "CHeanged")
      if(this.userFilter == 'oncologist'){
        this.oncologist = true
       }else{
         this.other_doctor = false
         this.medical_researcher = false
         this.patient = false
       }
       if(this.userFilter == 'other_doctor'){
         this.other_doctor = true
       }else{
         this.oncologist = false
         this.medical_researcher = false
         this.patient = false
       }
      if(this.userFilter == 'medical_researcher'){
        this.medical_researcher = true
       }else{
         this.oncologist = false
         this.other_doctor = false
         this.patient = false
       }
       if(this.userFilter == 'patient'){
        this.patient = true
       }else{
         this.oncologist = false
         this.other_doctor = false
         this.medical_researcher = false
       }
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          if(this.userFilter == 'oncologist'){
            this.oncologist = true
           }else if(this.userFilter == 'other_doctor'){
             this.other_doctor = true
           }else if(this.userFilter == 'medical_researcher'){
            this.medical_researcher = true
           }else if(this.userFilter == 'patient'){
            this.patient = true
           }
          let data = new FormData();
          if (this.avatar != null && this.avatar != '') {
            data.append('avatar', this.avatar);
          }
          data.append('first_name', this.first_name);
          data.append('last_name', this.last_name);
          data.append('department', this.department);
          data.append('area_of_work', this.area_of_work);
          data.append('designation', this.designation);
          data.append('country', this.country);
          data.append('oncologist', this.oncologist);
          data.append('other_doctor', this.other_doctor);
          data.append('medical_researcher', this.medical_researcher);
          data.append('patient', this.patient);
          this.$store.dispatch('updateProfileFun', data)
            .then((res) => {
              toast.success(res.data.msg);
              this.getUserDetailsAgain()
            }).catch((err) => {
              toast.error(err.data.user_msg || err.data.data.email);
            })
          return;
        }
      });
    },
    updatedProfileNumber() {
      this.phoneNumUpdatedPopup = true
      $('body').addClass('mobileNoupdatePopup')
      setTimeout(()=>{    
      $('.option-list').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).find('ul').slideToggle(100);
        if ($(this).hasClass('open')) {
          $('.dropdown-arrow').text('▼');
        } else {
          $('.dropdown-arrow').text('▲');
        }
      });
      },100)
    },
    updatedProfileNumberPopupClosed() {
      this.phoneNumUpdatedPopup = false
      this.otpVerifyPopupShow = false;
      $('body').removeClass('mobileNoupdatePopup')
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.onCHangeCountryCode = country.dialCode
    },
    validateBeforeMobileNoSubmit() {
      if(this.onCHangeCountryCode != ''){
        this.sendingCountryCode = '+' + this.onCHangeCountryCode
      }else{
        this.sendingCountryCode = this.phone.countryCode
      }
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch('mobileNoCreatedFun', {
            mobile:this.phone.number,
            mobile_country_code:this.sendingCountryCode
          })
            .then((res) => {
              if (res.status === 200) {
                toast.success(res.data.user_msg);
                this.otpVerifyPopupShow = true;
                this.phoneNumber.fullOTP = ''
              }
            }).catch((err) => {
              toast.error(err.data.data.non_field_errors || err.data.msg);
            })
          return;
        }
      });
    },
    validateBeforeMobileNoVerifySubmit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch('mobileNoVerifiedFun', {
            mobile:this.phone.number,
            otp: this.phoneNumber.fullOTP,
            mobile_country_code:this.sendingCountryCode
          })
            .then((res) => {
              if (res.status === 200) {
                toast.success(res.data.user_msg);
                this.getUserDetailsAgain()
                this.phoneNumUpdatedPopup = false
                this.otpVerifyPopupShow = false;
                this.phoneNumber.fullOTP = ''
                // this.phone.number = ''
                this.sendingCountryCode = ''
                // this.onCHangeCountryCode = ''
                $('body').removeClass('mobileNoupdatePopup')
              }
            }).catch((err) => {
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      });
    }
  },
  watch: {
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    setInitialState() {
      if (this.userDetails != undefined) {
        this.first_name = this.userDetails.first_name || '',
        this.last_name = this.userDetails.last_name || '',
        this.department = this.userDetails.profile.department || '',
        this.designation = this.userDetails.profile.designation || '',
        this.country = this.userDetails.profile.country || '',
        this.city = this.userDetails.profile.city || '',
        this.area_of_work = this.userDetails.profile.company || '',
        this.area_of_interest = this.userDetails.profile.area_of_interest || '',
        this.avatar = this.userDetails.profile.avatar
        this.oncologist = this.userDetails.profile.oncologist
        if(this.oncologist == true){
          this.userFilter = 'oncologist'
        }
        this.other_doctor = this.userDetails.profile.other_doctor
        if(this.other_doctor == true){
          this.userFilter = 'other_doctor'
        }
        this.medical_researcher = this.userDetails.profile.medical_researcher
        if(this.medical_researcher == true){
          this.userFilter = 'medical_researcher'
        }
        this.patient = this.userDetails.profile.patient
        if(this.patient == true){
          this.userFilter = 'patient'
        }
        this.phone.countryCode = this.userDetails.profile.mobile_country_code
        this.fullMobileCountryCode = this.phone.countryCode + ' ' + (this.userDetails.profile.mobile || '')
        this.phone.number = this.userDetails.profile.mobile
        setTimeout(() =>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode.split('+')
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == countrySplit[1])[0].iso2;
            }
        },100)
      }
      return
    }
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('mobileNoupdatePopup')
    next();
  },
}